export const viewTitle = "Справочник сроков хранения";
export const viewUniqKey = "storageTerms";
